import { ArrowRight, Mail } from "lucide-react";
import { scrollToCalculator } from "@/lib/notify";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta-section"
            className="relative bg-mesh-emerald text-white py-24 md:py-32 px-4 md:px-8 overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid-emerald opacity-60" aria-hidden />
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0 flex justify-center"
            >
                <div className="h-[480px] w-[1100px] rounded-full bg-emerald-500/15 blur-[140px] mt-20" />
            </div>

            <div className="relative mx-auto max-w-5xl text-center">
                <span className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-500/10 px-3 py-1 text-[11px] tracking-[0.25em] uppercase font-bold text-emerald-300">
                    Make the switch
                </span>
                <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
                    Stop overpaying banks for{" "}
                    <span className="text-gradient-emerald">international payments.</span>
                </h2>
                <p className="mt-5 text-zinc-300 text-base sm:text-lg max-w-2xl mx-auto">
                    Built for Indian businesses scaling globally. Transparent FX, fast settlements
                    and automated compliance — on a single platform.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
                    <button
                        type="button"
                        data-testid="final-get-started-btn"
                        onClick={scrollToCalculator}
                        className="group inline-flex h-14 w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-gold px-8 text-base font-bold text-zinc-950 glow-gold transition-all hover:-translate-y-0.5 hover:bg-gold-400"
                    >
                        Get Started
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                    </button>
                    <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=Info@truopay.com&su=Contact%20Sales%20-%20TruoPay"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-connect-sales-btn"
                        className="inline-flex h-14 w-full sm:w-auto items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-8 text-base font-semibold text-white hover:bg-white/10 transition-colors"
                    >
                        <Mail className="h-4 w-4" />
                        Contact Sales
                    </a>
                </div>

                <a
                    href="mailto:Info@truopay.com?subject=Contact%20Sales%20-%20TruoPay"
                    data-testid="final-sales-email"
                    className="mt-5 inline-flex items-center gap-2 text-sm font-mono text-emerald-300 hover:text-emerald-200 transition-colors"
                >
                    <Mail className="h-3.5 w-3.5" />
                    Info@truopay.com
                </a>

                <div className="mt-12 grid grid-cols-3 max-w-xl mx-auto text-left sm:text-center gap-6">
                    <div>
                        <div className="font-heading text-3xl sm:text-4xl font-extrabold font-mono">
                            0.3%
                        </div>
                        <div className="text-xs text-zinc-400 mt-1">flat FX margin</div>
                    </div>
                    <div>
                        <div className="font-heading text-3xl sm:text-4xl font-extrabold font-mono">
                            &lt;24h
                        </div>
                        <div className="text-xs text-zinc-400 mt-1">INR credit</div>
                    </div>
                    <div>
                        <div className="font-heading text-3xl sm:text-4xl font-extrabold font-mono">
                            100%
                        </div>
                        <div className="text-xs text-zinc-400 mt-1">auto compliance</div>
                    </div>
                </div>
            </div>
        </section>
    );
}
